import { render, staticRenderFns } from "./UGCBanner.vue?vue&type=template&id=4b5a4592&scoped=true&lang=pug&"
import script from "./UGCBanner.vue?vue&type=script&lang=js&"
export * from "./UGCBanner.vue?vue&type=script&lang=js&"
import style0 from "./UGCBanner.vue?vue&type=style&index=0&id=4b5a4592&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5a4592",
  null
  
)

export default component.exports